var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("JoinORPInvite", {
    attrs: {
      "applicant-name": _vm.inviteData.publisherName,
      "applicant-type": "publisher",
      "account-name": _vm.inviteData.accountName,
      "invite-status": _vm.inviteStatus,
      "is-whitelabel": _vm.isWhitelabel,
      "invite-data": _vm.inviteData
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }